module.exports = __webpack_public_path__ + "static/media/red-x.d494bd24.png";